/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberRelative } from './MemberRelative';
import {
    MemberRelativeFromJSON,
    MemberRelativeFromJSONTyped,
    MemberRelativeToJSON,
} from './MemberRelative';

/**
 * 
 * @export
 * @interface ListLinkedMemberRelatives200Response
 */
export interface ListLinkedMemberRelatives200Response {
    /**
     * 
     * @type {Array<MemberRelative>}
     * @memberof ListLinkedMemberRelatives200Response
     */
    data: Array<MemberRelative>;
}

/**
 * Check if a given object implements the ListLinkedMemberRelatives200Response interface.
 */
export function instanceOfListLinkedMemberRelatives200Response(value: object): value is ListLinkedMemberRelatives200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListLinkedMemberRelatives200ResponseFromJSON(json: any): ListLinkedMemberRelatives200Response {
    return ListLinkedMemberRelatives200ResponseFromJSONTyped(json, false);
}

export function ListLinkedMemberRelatives200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLinkedMemberRelatives200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MemberRelativeFromJSON)),
    };
}

export function ListLinkedMemberRelatives200ResponseToJSON(value?: ListLinkedMemberRelatives200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(MemberRelativeToJSON)),
    };
}

